import React from 'react';
import { useSelector } from 'react-redux';
import { selectCaseById } from '@debbie/cortex/dist/cases/selectors';
import { Panel } from '..';
import CaseVouchers from '../economy/case-vouchers/CaseVouchers';
import HistItem from './HistItem';
const EconomyItem = (props) => {
    const lang = useSelector((s) => s.lang);
    const singleCase = useSelector((s) => selectCaseById(s, props.caseId));
    return (React.createElement(HistItem, { date: props.historyItem.date, timespan: props.historyItem.timespan, heading: lang.economy.histItemHeader },
        React.createElement(Panel, null, singleCase && (React.createElement(CaseVouchers, { singleCase: singleCase, caseVouchers: props.historyItem.data.caseVouchers })))));
};
export default EconomyItem;
//# sourceMappingURL=EconomyItem.js.map